import React from 'react';

export default class EsignLandingPageRadioButtons extends React.PureComponent {
  static resetUploadDestination(clickEvent, destination) {
    clickEvent.preventDefault();
    window.Upload.resetUploadDestination(clickEvent, destination);
  }

  render() {
    return (
      <div className="edit-pages-radio-button-wrapper">
        <div className="edit-pages-radio-button-section">
          <button
            className="edit-pages-radio-button-outer free-write active"
            onClick={(e) => { EsignLandingPageRadioButtons.resetUploadDestination(e, 'free-write'); }}
          >
            <div className="edit-pages-radio-button-inner" />
          </button>
          <span className="edit-pages-radio-button-text">I want to edit my document only</span>
        </div>
        <div className="edit-pages-radio-button-section">
          <button
            className="edit-pages-radio-button-outer rearrange"
            onClick={(e) => { EsignLandingPageRadioButtons.resetUploadDestination(e, 'rearrange'); }}
          >
            <div className="edit-pages-radio-button-inner" />
          </button>
          <span className="edit-pages-radio-button-text">
            I want to edit my document & rearrange pages
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src-react/EsignLandingPage/EsignLandingPageRadioButtons.jsx